import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons"

export const PlusCircle = (props) => {
  return <FontAwesomeIcon faIcon={faPlusCircle} {...props} />
}
